
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bulk_payment_summary",
      function () {
        return require("private-next-pages/bulk_payment_summary.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bulk_payment_summary"])
      });
    }
  